import { IS_PRODUCTION } from '@/utils/helpers/constants';

export const MLP_LEADERBOARD_TAB_OPTIONS = [
  { value: 1, label: 'Premier' },
  { value: 2, label: 'Challenger' },
];

export const MLP_LEADERBOARD_DEFAULT_TAB_VALUE = { value: 1, label: 'Premier' };

export const MLP_TEAM_LEAGUE_ORG_UUID = IS_PRODUCTION
  ? 'f6f5296b-b9a6-4d25-a295-29f461de56d2'
  : 'c1e16af8-4b0e-456d-a8a8-d0fe1d5d630c';
export const MLP_TEAM_LEAGUE_TEAM_LEAGUE_UUID = IS_PRODUCTION
  ? '2f129d1d-0202-4d55-8448-bfafc0872305'
  : '4e239924-3cba-4ce9-a996-26925ef940d1';
export const MLP_TEAM_LEAGUE_SLUG = IS_PRODUCTION ? 'major-league-pickleball' : 'test_league_mlp';
export const MLP_PREMIER_DIVISION_UUID = IS_PRODUCTION
  ? '5668ed34-5aa6-494d-808f-f5512ae89379'
  : '00c2ebb3-98a1-4d12-8db0-d82cec5a3ecf';
export const MLP_CHALLENGER_DIVISION_UUID = IS_PRODUCTION
  ? '6fa08298-bfda-40c9-86bc-4e369aac8b77'
  : 'fef6cb14-4c14-42bd-9a26-79853c395fea';
